
import { Component, Vue } from "vue-property-decorator";
import Publicacion from "@/components/Noticias/NewPublicacion.vue";

@Component({
  components: {
    Publicacion
  }
})
export default class PublicacionView extends Vue {}
